module.exports = __webpack_public_path__ + "static/media/divider.bfa33612.svg";